import UnlinkedActivityTimelineRecordLayout from 'domain/sales/unlinkedEmails/UnlinkedActivityTimelineRecordLayout';
import { READ_UNLINKED_CRM_ACTIVITY_PERMISSION } from 'domain/sales/unlinkedEmails/shared/unlinkedCrmActivitiesService';

const useCrmUnlinkedActivityRegistry = () => ({
  isApplicable: (item: { activity: any }) => item.activity,
  source: 'activity',
  urlPostfix: 'activities',
  RecordLayout: UnlinkedActivityTimelineRecordLayout,
  name: 'Activity',
  permissionToCheck: READ_UNLINKED_CRM_ACTIVITY_PERMISSION,
  withoutAddFunctionality: true,
});

export default useCrmUnlinkedActivityRegistry;
